import { path, nth, compose, pathOr } from 'ramda'
import { globalizeSelectors } from 'zeal-redux-utils'

const localState = path(['app', 'debate', 'question'])

const loaded = path(['loaded'])
const index = path(['questions'])
const current = state => {
  const selectedQuestion = pathOr(0, ['selectedQuestion'])(state)

  return compose(
    nth(selectedQuestion),
    index
  )(state)
}

export default globalizeSelectors(localState, {
  index,
  current,
  loaded
})



// WEBPACK FOOTER //
// ./client/modules/debate/selectors/question.js